
import { Component, Prop, Watch } from 'vue-property-decorator'
import axios from 'axios';
import {MstCompanyVO} from './vo/company.vo';
import { MstMemDeliveryVO } from '@/views/biz/mypage/vo/mypage.vo'
import DeliveryAddressFormPop from './DeliveryAddressFormPop.vue'
import { MstOrderVO } from './vo/order.vo';
import CommonPopup from '../../../components/CommonPopup.vue';
import CommonUtils from '@/common-utils';


@Component({
    components: {DeliveryAddressFormPop, CommonPopup}
})
export default class DeliveryAddressChoicePop extends CommonPopup {
  @Prop() order!: MstOrderVO;

  branches = [] as Array<MstCompanyVO>;
  currentBranch = {} as MstCompanyVO;

  addressList: Array<MstMemDeliveryVO> = [] as Array<MstMemDeliveryVO>;

  showDeliveryAddressFormPop = false;

  deliveryCdToModify = '';

  // 선택
  choice(item: MstMemDeliveryVO): void {
    this.$emit('update:opened', false);
    this.order.recvNm = item.recvNm;
    this.order.hpNo = item.hpNo;
    this.order.addr = item.addr;
    this.order.addrDetail = item.addrDetail;
    this.order.addrSerialNo = item.addrSerialNo;
    this.order.deliveryCd = item.deliveryCd;
    this.order.postNo = item.postNo;
    this.order.defaultDlvryYn = item.defaultDlvryYn;
    
    if(CommonUtils.isSystemLocale('ko')) {
      this.order.persEcm = item.persEcm;
    }
    this.$emit('update:order', this.order);
  }

  // init
  @Watch('opened')
  @Watch('showDeliveryAddressFormPop')
  onOpened(): void {
    // 입력 팝업이 열려 있으면 대상 아님.
    if(this.showDeliveryAddressFormPop){
      return;
    }
    window.scrollTo(0,0);
    axios.get('/mypage/profile/address-management')
    .then(r => {
      this.addressList = r.data;
    }, err => {
      console.error(err)
    })
  }

  //method
  openFormPopup(deliveryCd: string | null) {
    if(deliveryCd) {
      this.deliveryCdToModify = deliveryCd;
    } else {
      this.deliveryCdToModify = '';
    }
    this.showDeliveryAddressFormPop=true;
  }

}
